export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14866.b7dd7173.jpg";